module.exports = __webpack_public_path__ + "static/comscore-b2d4919b9032fafc211e9ecc28c401bd.svg";